<template>
  <div class="invoice-message">
    <div class="title_box">发票备注</div>
    <el-form :model="form" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="起运地">
            <el-cascader
              :disabled="isDisable"
              v-model="form.loadPlace"
              :options="options"
              @change="startLocationChoose"
              placeholder="请选择起运地"
              clearable
              :props="{ value: 'label' }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="目的地">
            <el-cascader
              v-model="form.unloadPlace"
              :options="options"
              :disabled="isDisable"
              @change="endLocationChoose"
              placeholder="请选择目的地"
              :props="{ value: 'label' }"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="货物名称">
            <!-- <el-input
              v-model="form.goodsName"
              placeholder="请输入货物名称"
              clearable
            /> -->
            <el-cascader
              v-model="form.coalTypeName"
              :options="goodsTypeDict"
              @change="typeDictChoose"
              placeholder="请选择目的地"
              clearable
              :disabled="isDisable"
              :props="{ value: 'label' }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车牌号">
            <el-input
              v-model="form.vehicleLicense"
              placeholder="请输入车牌号"
              :disabled="isDisable"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="车种车型">
            <div v-if="!isDisable">
              <el-tag
                v-for="(item, index) in form.carModel"
                :key="index"
                closable
                @close="removeCarModel(item)"
                style="margin-right:4px;margin-bottom:2px;"
              >
                {{ item.name }}
              </el-tag>
            </div>
            <div v-else>
              <template v-if="form.carModel.length">
                <span v-for="(item, index) in form.carModel" :key="index"
                  >{{ item.name }} &ensp;</span
                >
              </template>
              <span style="color:gray;" v-else>--</span>
            </div>
            <el-popover placement="top-start" width="400" trigger="hover">
              <div class="modal_box">
                <div
                  class="modal_item"
                  v-for="(item, index) in carModelOption"
                  :key="index"
                  @click="changeCarModal(item)"
                >
                  {{ item.name }}
                </div>
              </div>
              <div v-if="!isDisable" class="select_box" slot="reference">
                请选择
              </div>
            </el-popover>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="其他">
            <el-input
              :disabled="isDisable"
              v-model="form.other"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="checkbox_box" v-if="!isDisable">
        <el-checkbox v-model="checked">是否将备注同步至发票</el-checkbox>
      </div>

      <el-divider content-position="left" v-if="hasFormData && checked"
        >信息预览</el-divider
      >
      <div class="preview-info" v-if="hasFormData && checked">
        <div v-if="form.loadPlace.length || form.unloadPlace.length">
          {{
            `起运地-目的地:${form.loadPlace.join("")}-${form.unloadPlace.join(
              ""
            )}`
          }}
        </div>
        <div>
          <span v-if="form.coalTypeName.length"
            >{{ `货物名称:${form.coalTypeName[1]}` }}&ensp;</span
          >
          <span v-if="form.carModel.length"
            >{{
              `车辆类型:${form.carModel.map(item => item.name).join("、")}`
            }}&ensp;</span
          >
          <span v-if="form.vehicleLicense"
            >{{ `车牌号:${form.vehicleLicense}` }}&ensp;
          </span>
          <span v-if="form.other">{{ form.other }}</span>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode
} from "element-china-area-data";
import { getGoodsTypeDict, getListDict } from "@/api/shipment";
export default {
  props: {
    latestRecord: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      checked: false,
      options: regionDataPlus,
      startLocationOptions: [],
      endLocationOptions: [],
      goodsTypeDict: [],
      carModelOption: [],
      form: {
        loadPlace: [],
        unloadPlace: [],
        coalTypeName: [],
        vehicleLicense: "",
        carModel: [],
        other: ""
      },
      copyForm: {}
    };
  },
  computed: {
    ischange() {
      return JSON.stringify(this.form) !== JSON.stringify(this.copyForm);
    },
    isDisable() {
      return this.type === "detail";
    },

    hasFormData() {
      console.log("hasFormData====", this.form);
      return (
        !!this.form.loadPlace.length ||
        !!this.form.unloadPlace.length ||
        !!this.form.coalTypeName.length ||
        !!this.form.vehicleLicense ||
        !!this.form.coalTypeName.length ||
        !!this.form.carModel.length ||
        !!this.form.other
      );
    },
    startLocationText() {
      if (!this.startLocationOptions.length) return "";
      return `${this.form.startProvince}${this.form.startCity}${
        this.form.startArea
      }`;
    },
    endLocationText() {
      if (!this.endLocationOptions.length) return "";
      return `${this.form.endProvince}${this.form.endCity}${this.form.endArea}`;
    }
  },
  watch: {
    latestRecord: {
      handler(newVal) {
        console.log("最新记录", newVal);
        if (newVal) {
          this.getListDict();
          this.form = {
            loadPlace:
              (this.latestRecord.shipperProvice
                ? [
                    this.latestRecord.shipperProvice,
                    this.latestRecord.shipperCity,
                    this.latestRecord.shipperArea
                  ]
                : this.latestRecord.loadPlaceArray) || [],
            unloadPlace:
              (this.latestRecord.consigneeProvice
                ? [
                    this.latestRecord.consigneeProvice,
                    this.latestRecord.consigneeCity,
                    this.latestRecord.consigneeArea
                  ]
                : this.latestRecord.unloadPlaceArray) || [],
            // 货物
            coalTypeName:
              (this.latestRecord.coalBigTypeName
                ? [
                    this.latestRecord.coalBigTypeName,
                    this.latestRecord.coalTypeName
                  ]
                : this.latestRecord.coalTypeName
                ? this.latestRecord.coalTypeName.split(",")
                : []) || [], //货物子类
            carModel: [],
            vehicleLicense: this.latestRecord.vehicleLicense, //车牌
            other: this.latestRecord.other || "",
            // 收货
            consigneeProvice: this.latestRecord.consigneeProvice,
            consigneeCity: this.latestRecord.consigneeCity,
            consigneeArea: this.latestRecord.consigneeArea,
            // 发货
            shipperProvice: this.latestRecord.shipperProvice,
            shipperCity: this.latestRecord.shipperCity,
            shipperArea: this.latestRecord.shipperArea
          };
          this.copyForm = JSON.parse(JSON.stringify(this.form));
        }
      },
      deep: true,
      immediate: true
    },
    type: {
      handler(newVal) {
        console.log("type=======检测", newVal, this.hasFormData);
        if (newVal === "audit" && this.hasFormData) {
          this.checked = true;
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getGoodsTypeDictApi();
  },
  methods: {
    getDisplayText() {
      const texts = [];

      if (this.form.loadPlace.length || this.form.unloadPlace.length) {
        texts.push(
          `起运地-目的地:${this.form.loadPlace.join(
            ""
          )}-${this.form.unloadPlace.join("")}  `
        );
      }

      if (this.form.coalTypeName.length) {
        texts.push(`货物名称: ${this.form.coalTypeName[1]}  `);
      }

      if (this.form.carModel.length) {
        texts.push(
          `车辆类型:${this.form.carModel.map(item => item.name).join("、")}  `
        );
      }

      if (this.form.vehicleLicense) {
        texts.push(`车牌号：${this.form.vehicleLicense}  `);
      }

      if (this.form.other) {
        texts.push(this.form.other);
      }
      return texts.join("");
    },
    getFormInfo() {
      let data = {
        loadPlace: this.form.loadPlace,
        unloadPlace: this.form.unloadPlace,
        coalTypeName: this.form.coalTypeName.join(","),
        carModel: this.form.carModel.map(item => item.code).join(","),
        vehicleLicense: this.form.vehicleLicense,
        other: this.form.other,
        remark: this.getDisplayText(),
        code: this.latestRecord.code || null
      };
      return data;
    },
    removeCarModel(e) {
      console.log("移除====", e);
      let index = this.form.carModel.findIndex(model => model.name === e.name);
      if (index !== -1) {
        this.form.carModel.splice(index, 1);
      }
    },
    changeCarModal(item) {
      console.log("车型", item);
      let arr = this.form.carModel || [];
      if (!arr.some(model => model.name === item.name)) {
        this.form.carModel.push(item);
      }
    },
    async getListDict() {
      let res = await getListDict({ types: "app_vehicleClassification" });
      this.carModelOption = res.data[0].dictList;
      console.log("车型？？？？？？", this.latestRecord.carModel);
      if (this.latestRecord.carModel) {
        let arr = this.latestRecord.carModel.split(",");
        console.log("选中车型====arr", arr);
        let newArr = [];
        arr.forEach(item => {
          let obj = this.carModelOption.find(model => model.code === item);
          if (obj) {
            newArr.push(obj);
          }
        });
        this.form.carModel = newArr;
        this.copyForm.carModel = newArr;
        console.log("选中车型====", newArr);
      }
      console.log("车型", res);
    },
    typeDictChoose(e) {
      console.log(e);
    },
    getGoodsTypeDictApi() {
      getGoodsTypeDict().then(res => {
        console.log(res);
        if (res.status === 0) {
          this.goodsTypeDict = res.data.records;
        }
      });
    },
    startLocationChoose(value) {
      console.log("装货", value);
      if (!value || !value.length) {
        this.form.startProvince = "";
        this.form.startCity = "";
        this.form.startArea = "";
        return;
      }
      this.form.startProvince = CodeToText[value[0]];
      this.form.startCity = CodeToText[value[1]];
      this.form.startArea = CodeToText[value[2]];
    },
    endLocationChoose(value) {
      if (!value || !value.length) {
        this.form.endProvince = "";
        this.form.endCity = "";
        this.form.endArea = "";
        return;
      }
      this.form.endProvince = CodeToText[value[0]];
      this.form.endCity = CodeToText[value[1]];
      this.form.endArea = CodeToText[value[2]];
    }
  }
};
</script>
<style lang="scss" scoped>
.checkbox_box {
  text-align: right;
}
.select_box {
  width: 50px;
  color: #1890ff;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
.modal_box {
  display: flex;
  flex-wrap: wrap;
  .modal_item {
    color: #1890ff;
    margin: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    &:hover {
      opacity: 0.8;
    }
  }
}

.invoice-message {
  padding: 20px;
  .preview-info {
    padding: 16px;
    background-color: #f5f7fa;
    border-radius: 4px;
    p {
      margin: 8px 0;
      color: #606266;
      &:first-child {
        margin-top: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.title_box {
  font-weight: bold;
  width: 80px;
  font-size: 18px;
  margin-bottom: 10px;
}
</style>
